import { render } from "./SkeletonText.vue?vue&type=template&id=0eb6108a"
import script from "./SkeletonText.vue?vue&type=script&lang=js"
export * from "./SkeletonText.vue?vue&type=script&lang=js"

import "./SkeletonText.vue?vue&type=style&index=0&id=0eb6108a&lang=scss"

import exportComponent from "/Users/aacassandra/Documents/vue3/aacassandra-github/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__